export default "__VITE_ASSET__qGglRHNM__"